import { render } from "./TextareaInputConfig.vue?vue&type=template&id=290cd668&ts=true"
import script from "./TextareaInputConfig.vue?vue&type=script&lang=ts"
export * from "./TextareaInputConfig.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__